import {EquipmentCategory, UpdateEquipmentCategoryDto} from "../../../../model/Dto/Dict/EquipmentCategory";
import {ApiRequest, RequestMethod} from "../../../request";

export async function updateEquipmentCategory(id: string, data: UpdateEquipmentCategoryDto): Promise<EquipmentCategory | null> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.POST);
    apiRequest.setUrl(`/api/equipment-category/${id}`);
    apiRequest.setJsonBody(data);
    const response: any = await apiRequest.send();
    if (response.status === 200) return response.data;
    return null;
}